import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const initialState = Immutable({
  loading: true,
  cities: [],
  mostExplored : [],
  localExperiences : [],
  topRead : [],
  topExperiences : []
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.LOADED:
      return {
        ...state,
        loading: false,
        cities: action.cities,
        mostExplored: action.mostExplored,
        localExperiences: action.localExperiences,
        topRead: action.topRead,
        topExperiences: action.topExperiences
      };
    default:
      return state;
  }
}

//Selectors
export function getValue(state, key) {
  const value = state["experiences"][key];
  switch (key) {
    default:
      return value;
  }
}

export function getAllValues(state, key) {
  return state["experiences"];
}